module.exports = __webpack_public_path__ + "static/media/dashboard-right-arrow-mobile.d5fae935.png";